import { MediaObject } from 'types'
import validators from './base'
import { ScheduledPostSettings } from 'api/clients/ScheduledPostsClient'

// Source https://www.facebook.com/business/help/1692533511105458

const facebookContentValidator = (content: string): string[] => {
  const rules = {
    maxCharacters: 33_000,
  }

  let errors = validators.validateTextLength(content, rules.maxCharacters)

  return errors
}

const facebookFileValidator = (files: MediaObject[]): string[] => {
  const rules = {
    minImages: 0,
    maxImages: 10,
  }

  return validators.validateFileCount(files, rules.minImages, rules.maxImages)
}

const facebookVideosSizeValidator = (files: MediaObject[]): string[] => {
  const rules = {
    maxSize: 10 * 1024 * 1024 * 1024, // 10GB
  }

  return validators.validateVideosSize(files, rules.maxSize, 'GB')
}

const facebookImageSizeValidator = (files: MediaObject[]): string[] => {
  const rules = {
    maxSize: 10 * 1024 * 1024, // 10MB
  }

  return validators.validateImagesSize(files, rules.maxSize, 'MB')
}

const facebookDurationValidator = (files: MediaObject[]): string[] => {
  const rules = {
    minDuration: 1,
    maxDuration: 14400, // 240 minutes
  }

  return validators.validateVideosDuration(files, rules.minDuration, rules.maxDuration)
}

const facebookAspectRatioValidator = (files: MediaObject[]): string[] => {
  const rules = {
    minAspectRatio: 0.53,
    maxAspectRatio: 1.77,
  }

  const labels = {
    minAspectRatio: '9:16',
    maxAspectRatio: '16:9',
  }

  return validators.validateVideosAspectRatio(
    files,
    rules.minAspectRatio,
    rules.maxAspectRatio,
    labels.minAspectRatio,
    labels.maxAspectRatio,
  )
}

const facebookFormatValidator = (files: MediaObject[]): string[] => {
  const formats = ['video/mp4', 'video/quicktime']

  return validators.validateVideosFormat(files, formats, 'Facebook')
}

const facebookVideosCountValidator = (files: MediaObject[]): string[] => {
  return validators.validateVideosCount(files, 0, 1)
}

const facebookPostSettingsValidator = (_settings?: ScheduledPostSettings): string[] => {
  return []
}

const facebookValidators = {
  validateContent: facebookContentValidator,
  validateFiles: facebookFileValidator,
  validateVideosSize: facebookVideosSizeValidator,
  validateImagesSize: facebookImageSizeValidator,
  validateVideosDuration: facebookDurationValidator,
  validateVideosAspectRatio: facebookAspectRatioValidator,
  validateVideosFormat: facebookFormatValidator,
  validateVideosCount: facebookVideosCountValidator,
  validatePostSettings: facebookPostSettingsValidator,
}

export default facebookValidators
